import { gql } from "@apollo/client";

export const DELETE_SADDLE = gql`
mutation deleteSaddleFitSaddle($input: DeleteSaddleFitSaddleInput!) {
    deleteSaddleFitSaddle(input: $input) {
        pk
        sk
    }
}`